export class Paiement {
  public ncarte:string;
  public mm:string;
  public aa:string;
  public ccv:string;
  constructor()
  {}
}
